import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { Creators as NewspapersCreators } from '../../store/ducks/newspapers';
import Loading from '../../components/Loading';
import NewspapersList from '../../components/NewspapersList';
import MenuStates from '../../components/MenuStates';

class Newspapers extends Component {
  static propTypes = {
    getSearch: PropTypes.func.isRequired,
  };

  componentWillMount() {
    const parsed = queryString.parse(this.props.location.search);
    const params = { uf: this.props.match.params.uf, query: parsed.q };
    this.props.getSearch(params);
  }

  getTitle() {
    var title = '';
    for (const key in this.props.states) {
      if (this.props.states[key].uf === this.props.match.params.uf.toUpperCase()) {
        var title = ` ${this.props.states[key].state}`;
      }
    }
    return title;
  }

  getSearchDescription() {
    const parsed = queryString.parse(this.props.location.search);
    if (parsed.q) {
      return (
        <p>
          Exibindo Resultado da busca por <strong>{parsed.q}</strong>
        </p>
      );
    }
  }

  render() {
    if (this.props.newspapers.search.loading) {
      return <Loading />;
    }

    return (
      <Fragment>
        <div className="row main-newspapers">
          <div className="col-md-2">
            <MenuStates />
          </div>
          <div className="col-md-10">
            <h1 className="border-bottom-gray">
              <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Jornais</span>
              <span style={{ color: '#666' }}>{this.getTitle()}</span>
            </h1>
            {this.getSearchDescription()}
            <NewspapersList newspapers={this.props.newspapers.search.data} />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  newspapers: state.newspapers,
  states: state.states.states,
  estado: state,
});

const mapDispatchToProps = dispatch => bindActionCreators(NewspapersCreators, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Newspapers));



// WEBPACK FOOTER //
// ./src/pages/newspapers/index.js